import merge from 'lodash/merge';
import { fr as frFRAdapter, enUS as enUSAdapter } from 'date-fns/locale';

// core
import { enUS as enUSCore, frFR as frFRCore } from '@mui/material/locale';
// data-grid
import { enUS as enUSDataGrid, frFR as frFRDataGrid } from '@mui/x-data-grid';
// date-pickers
import { enUS as enUSDate, frFR as frFRDate } from '@mui/x-date-pickers/locales';

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
  {
    label: 'Sinhala',
    value: 'si',
    systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
    adapterLocale: frFRAdapter,
    icon: 'flagpack:lk',
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
